module.exports = __webpack_public_path__ + "img/ic_documents.51030c68.svg";